"use strict";
/* eslint-disable react/prop-types */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var wagtailConfig_1 = require("../../config/wagtailConfig");
var Icon_1 = __importDefault(require("../../components/Icon/Icon"));
var Button_1 = __importDefault(require("../../components/Button/Button"));
var PublicationStatus_1 = __importDefault(require("../../components/PublicationStatus/PublicationStatus"));
// Hoist icons in the explorer item, as it is re-rendered many times.
var childrenIcon = (react_1["default"].createElement(Icon_1["default"], { name: "folder-inverse", className: "icon--menuitem" }));
/**
 * One menu item in the page explorer, with different available actions
 * and information depending on the metadata of the page.
 */
var PageExplorerItem = function (_a) {
    var _b;
    var item = _a.item, onClick = _a.onClick, navigate = _a.navigate;
    var id = item.id, title = item.admin_display_title, meta = item.meta;
    var hasChildren = meta.children.count > 0;
    var isPublished = meta.status.live && !meta.status.has_unpublished_changes;
    var localeName = ((_b = meta.parent) === null || _b === void 0 ? void 0 : _b.id) === 1 && meta.locale && (wagtailConfig_1.LOCALE_NAMES.get(meta.locale) || meta.locale);
    return (react_1["default"].createElement("div", { className: "c-page-explorer__item" },
        react_1["default"].createElement(Button_1["default"], { href: "" + wagtailConfig_1.ADMIN_URLS.PAGES + id + "/", navigate: navigate, className: "c-page-explorer__item__link" },
            hasChildren ? childrenIcon : null,
            react_1["default"].createElement("h3", { className: "c-page-explorer__item__title" }, title),
            (!isPublished || localeName) &&
                react_1["default"].createElement("span", { className: "c-page-explorer__meta" },
                    localeName && react_1["default"].createElement("span", { className: "o-pill c-status" }, localeName),
                    !isPublished && react_1["default"].createElement(PublicationStatus_1["default"], { status: meta.status }))),
        react_1["default"].createElement(Button_1["default"], { href: "" + wagtailConfig_1.ADMIN_URLS.PAGES + id + "/edit/", className: "c-page-explorer__item__action c-page-explorer__item__action--small", navigate: navigate },
            react_1["default"].createElement(Icon_1["default"], { name: "edit", title: wagtailConfig_1.STRINGS.EDIT_PAGE.replace('{title}', title), className: "icon--item-action" })),
        hasChildren ? (react_1["default"].createElement(Button_1["default"], { className: "c-page-explorer__item__action", onClick: onClick, href: "" + wagtailConfig_1.ADMIN_URLS.PAGES + id + "/", navigate: navigate },
            react_1["default"].createElement(Icon_1["default"], { name: "arrow-right", title: wagtailConfig_1.STRINGS.VIEW_CHILD_PAGES_OF_PAGE.replace('{title}', title), className: "icon--item-action" }))) : null));
};
exports["default"] = PageExplorerItem;
